var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 当前页面不存在，请查看网址是否输入正确 "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }